export default __webpack_public_path__ + "images/RM.96e44cd.png";